import { IEvent } from "modules/event/types";
import { getWaitingUsers } from "modules/lobby/utils/lobbyFirestoreUtils";
import logger from "logging/logger";
import { useSelector } from "react-redux";
import { selectCurrentEventCompanyPlan } from "modules/event/selectors";
import { useEffect, useMemo, useState } from "react";
import { selectLiveUserCount } from "../redux/selectors";

const useEventLiveCapacity = (event: IEvent | null) => {
  const liveUserCount = useSelector(selectLiveUserCount);
  const currentEventCompanyPlan = useSelector(selectCurrentEventCompanyPlan);
  const [waitingLobbyUsers, setWaitingLobbyUsers] = useState(0);

  useEffect(() => {
    if (event) {
      const startIsEventFullCheck = async () => {
        if (event.isLobbyActive) {
          const incomingWaitingLobbyUsers = await getWaitingUsers(event.id);
          setWaitingLobbyUsers(incomingWaitingLobbyUsers);
        }
      };

      startIsEventFullCheck();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  const isEventFull = useMemo(() => {
    if (!event) {
      return false;
    }

    logger.info(
      `[isEventFull] event: ${event.id} liveCount: ${liveUserCount} waitingLobbyUsers: ${waitingLobbyUsers}`,
    );

    if (liveUserCount === 0 || !currentEventCompanyPlan) {
      return false;
    }

    const maxAllowed = currentEventCompanyPlan.settings.theater.maxCapacity;

    logger.info(
      `[isEventFull] event: ${event.id} liveCount: ${liveUserCount} max: ${maxAllowed} waitingLobbyUsers: ${waitingLobbyUsers}`,
    );

    return maxAllowed <= liveUserCount + waitingLobbyUsers;
  }, [currentEventCompanyPlan, event, liveUserCount, waitingLobbyUsers]);

  return {
    isEventFull,
  };
};

export default useEventLiveCapacity;
